var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c('div',[_c('div',{staticClass:"d-flex pt-2 justify-content-between align-items-center"},[_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.$t(_vm.filter.subline)))]),_c('Dropdown',{attrs:{"value":_vm.filter.active},on:{"input":_vm.handleDropdownInput}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }